import { render } from "./PassingTable.vue?vue&type=template&id=6156b45d&scoped=true"
import script from "./PassingTable.vue?vue&type=script&lang=js"
export * from "./PassingTable.vue?vue&type=script&lang=js"

import "./PassingTable.vue?vue&type=style&index=0&id=6156b45d&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6156b45d"]])

export default __exports__